import { Controller as RHFController, ControllerProps } from "react-hook-form";

import { CheckoutFormValues } from "./schema";

export function Controller<Name extends keyof CheckoutFormValues>(
  props: ControllerProps<CheckoutFormValues, Name>
) {
  return <RHFController {...props} />;
}
